/* Lamp Boy speed - product page colour galleries (assets/lb-variant-media.js)

   The product page is built with only the selected colour's photos
   (see snippets/lb-media-groups.liquid). The other colours' slides are left as
   empty, correctly sized placeholders; the theme's gallery script keeps them
   aside and swaps them in when the colour changes, exactly as before.

   This script fills those placeholders with Shopify's own render of this
   product section for that colour:
     - in the background, one colour at a time, a few seconds after the page
       has finished loading (skipped when the visitor has Data Saver on), and
     - straight away when a shopper hovers, touches or focuses a colour swatch.
   Each colour's main photo is then pre-loaded quietly, so switching colour
   shows it instantly.

   It also holds back the "last frame" video thumbnail until that thumbnail is
   actually on screen (it used to download the whole video on every visit). */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var sectionId = root.getAttribute('data-product-root');
  var mobile = window.matchMedia('(max-width: 1023px)');
  var videoObserver = null;
  var requests = {};
  var warmed = {};
  var slides = [];
  var thumbs = [];

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* ---------- "last frame" video thumbnails: load only when on screen ---------- */

  function loadVideoThumb(video) {
    var go = function () {
      var src = video.getAttribute('data-lb-src');
      if (!src) return;
      video.removeAttribute('data-lb-src');
      var show = function () { video.style.opacity = '1'; };
      video.addEventListener('loadeddata', show, { once: true });
      video.addEventListener('seeked', show, { once: true });
      video.preload = 'metadata';
      video.src = src;
    };
    if (document.readyState === 'complete') go();
    else window.addEventListener('load', go, { once: true });
  }

  function setupVideoThumbs(scope) {
    var videos = toArray(scope.querySelectorAll('video[data-lb-video-thumb][data-lb-src]'));
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(loadVideoThumb);
      return;
    }
    if (!videoObserver) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          videoObserver.unobserve(entry.target);
          loadVideoThumb(entry.target);
        });
      }, { rootMargin: '0px 200px' });
    }
    videos.forEach(function (video) { videoObserver.observe(video); });
  }

  /* ---------- other colours' photos ---------- */

  function placeholderVariantIds() {
    var ids = [];
    slides.forEach(function (li) {
      var ph = li.querySelector('[data-lb-deferred-media]');
      var id = ph && ph.getAttribute('data-lb-variant-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function sectionUrl(variantId) {
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  // Fetch this section rendered for `variantId` and copy that colour's slides and
  // thumbnails into our empty placeholders. Resolves to the slides/thumbs filled.
  function fill(variantId, urgent) {
    if (!variantId) return Promise.resolve({ slides: [], thumbs: [] });
    if (requests[variantId]) return requests[variantId];

    var init = { credentials: 'same-origin' };
    if (!urgent) init.priority = 'low';

    requests[variantId] = fetch(sectionUrl(variantId), init)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var result = { slides: [], thumbs: [] };

        var list = doc.querySelector('.splide--product > .splide__track > .splide__list');
        if (list) {
          slides.forEach(function (li) {
            if (!li.querySelector('[data-lb-deferred-media]')) return;
            var from = list.querySelector(':scope > [data-index="' + li.getAttribute('data-index') + '"]');
            if (from && from.querySelector('[data-product-single-media-wrapper]') && !from.querySelector('[data-lb-deferred-media]')) {
              li.innerHTML = from.innerHTML;
              result.slides.push(li);
            }
          });
        }

        var tlist = doc.querySelector('.splide--thumbnails .splide__list');
        if (tlist) {
          thumbs.forEach(function (li) {
            if (!li.querySelector('[data-lb-deferred-thumb]')) return;
            var from = tlist.querySelector('[data-lb-thumb-index="' + li.getAttribute('data-lb-thumb-index') + '"]');
            if (from && !from.querySelector('[data-lb-deferred-thumb]')) {
              // Lazy, so these only download once the thumbnail strip actually shows them
              // (never on desktop, where the strip is hidden).
              li.innerHTML = from.innerHTML.replace(/loading="eager"/g, 'loading="lazy"');
              setupVideoThumbs(li);
              result.thumbs.push(li);
            }
          });
        }
        return result;
      })
      .catch(function () {
        delete requests[variantId];
        return { slides: [], thumbs: [] };
      });

    return requests[variantId];
  }

  // Quietly download the first `count` photos of the given slides/thumbnails
  // (same srcset + sizes as the real image, so the browser reuses the download).
  function warm(items, count, priority) {
    items.slice(0, count).forEach(function (li) {
      var img = li.querySelector('img');
      if (!img) return;
      var pre = new Image();
      pre.decoding = 'async';
      try { pre.fetchPriority = priority; } catch (e) {}
      if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
      pre.src = img.getAttribute('src');
    });
  }

  function onSwatchIntent(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var input = target.closest('[data-single-option-selector]');
    if (!input) {
      var label = target.closest('label');
      input = label && (label.control || label.querySelector('[data-single-option-selector]'));
    }
    if (!input || !input.getAttribute) return;
    var id = input.getAttribute('data-variant-id');
    if (!id || warmed[id]) return;
    warmed[id] = true;
    fill(id, true).then(function (result) {
      warm(result.slides, mobile.matches ? 2 : 3, 'high');
      if (mobile.matches) warm(result.thumbs, 8, 'low');
    });
  }

  function idle(fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 4000 });
    else setTimeout(fn, 300);
  }

  function fillInBackground() {
    var connection = navigator.connection;
    if (connection && connection.saveData) return;
    var ids = placeholderVariantIds();
    (function next() {
      var id = ids.shift();
      if (!id) return;
      idle(function () {
        fill(id, false).then(function (result) {
          warm(result.slides, 1, 'low');
          next();
        });
      });
    })();
  }

  /* ---------- start ---------- */

  setupVideoThumbs(root);

  // The theme's gallery script takes other colours' slides out of the page once it
  // starts, but keeps them in its own lists - use those if it has already run.
  var state = {};
  try { state = (window.Alpine && window.Alpine.$data(root)) || {}; } catch (e) { state = {}; }
  var mainList = root.querySelector('.splide--product > .splide__track > .splide__list');
  var thumbList = root.querySelector('.splide--thumbnails .splide__list');

  slides = toArray(state.allSlides && state.allSlides.length ? state.allSlides : (mainList ? mainList.children : []));
  thumbs = toArray(
    state.allHorizontalThumbnailsSlides && state.allHorizontalThumbnailsSlides.length
      ? state.allHorizontalThumbnailsSlides
      : (thumbList ? thumbList.children : [])
  ).filter(function (li) { return li.hasAttribute('data-lb-thumb-index'); });

  if (!sectionId || !placeholderVariantIds().length) return;

  ['pointerover', 'pointerdown', 'touchstart', 'focusin'].forEach(function (type) {
    root.addEventListener(type, onSwatchIntent, { capture: true, passive: true });
  });

  // Safety net: if a colour is chosen before its photos were filled in, fill them now.
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.id) fill(String(variant.id), true);
  });

  function afterLoad() { setTimeout(fillInBackground, 3000); }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });
})();
